import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from './auth/services/auth.service';
import { changeEnvFavicon } from '~common/app/shared/utils/change-favicon';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit {
  authenticatedStatus$: Observable<any>;
  warningDisplayed = false;

  constructor(
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.authService
      .isAuthenticated()
      .subscribe(authenticated => {
        if (authenticated) {
          setTimeout(() => {
            this.authService.loadAuthenticated();
          }, 10);
        }
      });

    changeEnvFavicon(window.location.hostname);
  }

  isAuthenticated() {
    return this.authService.getAuthenticatedUser()
  }

  onWarningDisplayed(displayed) {
    this.warningDisplayed = displayed;
  }
}
